/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from 'react';
import AssignHelpButtonToManual from './AssignHelpButtonToManual';
import ProductClassificationSelection from './ClassificationSelection';
import ManualInformation from './ManualInformation';


interface Props {
    handleSubmit: Function
}
interface State {
    step: number
}
class UploadSteps extends React.Component<Props, State> {
    state = {
        step: 1
    };
    next = () => {
        this.setState(prevState => {
            return {
                step: prevState.step + 1
            };
        });
    };

    back = () => {
        this.setState(prevState => {
            return {
                step: prevState.step - 1
            };
        });
    };
    render() {
        const { step } = this.state;
        switch (step) {
            case 1: {
                const PCS: any = ProductClassificationSelection;
                return <PCS next={this.next} />;
            }
            case 2:
                const ManualInformationAny = ManualInformation as any;
                return (<ManualInformationAny next={this.next} back={this.back} />);
            case 3: {
                const HelpAssign: any = AssignHelpButtonToManual;
                return <HelpAssign back={this.back} handleSubmit={this.props.handleSubmit} />;
            }
            default:
                return null;
        }
    }
}
export default UploadSteps;
